var app = angular.module('leonardo');

var TaskStatusFilter = function (ReportService) {
  return function (option) {
    var name = '';
    angular.forEach(ReportService.STATUS_OPTIONS, function(value, key) {
      if (angular.isArray(option)) {
        if (_.contains(option, value.id))
          name += value.label + ', ';
      }
      else {
        if (key == option)
          name = value.label;
      }
    });
    if (angular.isArray(option))
      return name.slice(0, -2);
    else
      return name;
  }
};

app.filter('taskStatus', ['ReportService', TaskStatusFilter]);
